const tests = [];

test('Localstorage', done => {
	// Read from Localstorage
	const test = 'test_key';
	localStorage.setItem(test, test);
	if (localStorage.getItem(test) !== test) {
		done('Localstorage returned error');
	}
	done();
});

test('Layout FlexBox', done => {
	// Read from Localstorage
	let passed = false;

	try {
		passed = CSS.supports('display', 'flex');
	} catch {
		passed = document.createElement('p').style.flex === '';
	}

	if (passed) {
		done();
	} else {
		done('CSS Flexbox is unknown');
	}
});

function test(name, test) {
	tests.push([name]);

	const inst = tests.length - 1;

	const handler = err => {
		tests[inst].push(err);
	};

	try {
		test(handler);
	} catch (e) {
		handler(e.message);
	}
}

export default () => Promise.resolve().then(() => tests);
